<template>
    <div>
        <create-variable-card card-type="map"/>
        <create-formula-card/>
        <formula-list-table/>
    </div>
</template>

<script>

import FormulaListTable from "@/components/formula-table/FormulaListTable";
import CreateVariablesCard from "../../../components/calculation-table/CreateVariablesCard";
import CreateFormulaCard from "@/components/formula-table/CreateFormulaCard";
import {mapActions, mapState} from "vuex";

export default {
    name: "MapFormulaView",
    components: {
        'create-variable-card': CreateVariablesCard,
        'create-formula-card': CreateFormulaCard,
        'formula-list-table': FormulaListTable,
    },
    computed: {
        ...mapState('formula', ['colors', 'formulaTargets']),
    },
    methods: {
        ...mapActions('formula', ['fetchFormulaColors', 'fetchFormulaTargets', 'fetchAllFormulas'])
    },
    async beforeMount() {
        await this.fetchFormulaTargets('map')
        !this.colors.length && await this.fetchFormulaColors()
    },
    async mounted() {
        await this.fetchAllFormulas('map')
    }
}


</script>

<style scoped>

</style>